export const PHONES = [
  { display: "+61 432 402 555", tel: "+61432402555" },
  { display: "+61 424 381 244", tel: "+61424381244" },
];

export const EMAIL = "info@arcviewhomes.com.au";

export const HOURS = { days: "Monday – Friday", time: "10:00 AM – 6:00 PM" };

export const LOCATION = {
  line1: "Tarneit VIC 3029",
  line2: "Victoria, Australia",
  directions: "https://www.google.com/maps/search/?api=1&query=Tarneit+VIC+3029+Australia",
  embed:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d50452.8876423977!2d144.6393521!3d-37.8344652!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad68c1e48f7f2b1%3A0x504535201b138d0!2sTarneit%20VIC%203029%2C%20Australia!5e0!3m2!1sen!2sau!4v1710000000000!5m2!1sen!2sau",
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About Us", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Our Projects", href: "#projects" },
  { label: "Irregular Blocks", href: "#irregular-blocks" },
  { label: "Our Process", href: "#process" },
  { label: "FAQs", href: "#faqs" },
  { label: "Contact", href: "#contact" },
];

export const PROJECTS = [
  {
    index: "01",
    address: "25 Erin Dr, Fraser Rise VIC 3336",
    suburb: "Fraser Rise",
    description:
      "A custom residential project in Fraser Rise — one of the recent addresses the ArcView Homes team helped bring to life.",
    image: "/projects/project-01.jpg",
    link: "https://www.realestate.com.au/property/25-erin-dr-fraser-rise-vic-3336/",
  },
  {
    index: "02",
    address: "37 Arnison Rd, Tarneit VIC 3029",
    suburb: "Tarneit",
    description:
      "A custom residential project in Tarneit, close to home base — designed and built by the ArcView Homes team.",
    image: "/projects/project-02.jpg",
    link: "https://www.realestate.com.au/property/37-arnison-rd-tarneit-vic-3029/",
  },
  {
    index: "03",
    address: "30 Prosecco St, Tarneit VIC 3029",
    suburb: "Tarneit",
    description:
      "A custom residential project in Tarneit's growing west — another address brought from concept to handover.",
    image: "/projects/project-03.jpg",
    link: "https://www.realestate.com.au/property/30-prosecco-st-tarneit-vic-3029/",
  },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1787088988806-7ec503692b85?auto=format&fit=crop&w=2400&q=80",
  about:
    "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?auto=format&fit=crop&w=1600&q=80",
  irregular:
    "https://images.unsplash.com/photo-1788894499164-2df2512adaed?auto=format&fit=crop&w=1600&q=80",
  dream: "https://images.pexels.com/photos/8134821/pexels-photo-8134821.jpeg?auto=compress&cs=tinysrgb&w=2400",
};

export const GALLERY = [
  {
    src: "https://images.unsplash.com/photo-1777106322601-578dc9213ace?auto=format&fit=crop&w=1200&q=80",
    label: "Modern Exteriors",
    tall: true,
  },
  {
    src: "https://images.unsplash.com/photo-1629079448062-78cb01434ef6?auto=format&fit=crop&w=1200&q=80",
    label: "Kitchens",
  },
  {
    src: "https://images.pexels.com/photos/4458205/pexels-photo-4458205.jpeg?auto=compress&cs=tinysrgb&w=1200",
    label: "Floor Plans",
  },
  {
    src: "https://images.unsplash.com/photo-1627141234469-24711efb373c?auto=format&fit=crop&w=1200&q=80",
    label: "Streetscapes",
  },
  {
    src: "https://images.unsplash.com/photo-1760129745103-91c4022ed5fb?auto=format&fit=crop&w=1200&q=80",
    label: "Sloping Sites",
    tall: true,
  },
  {
    src: "https://images.pexels.com/photos/8089172/pexels-photo-8089172.jpeg?auto=compress&cs=tinysrgb&w=1200",
    label: "Open-Plan Living",
  },
  {
    src: "https://images.pexels.com/photos/37079556/pexels-photo-37079556.jpeg?auto=compress&cs=tinysrgb&w=1200",
    label: "Contemporary Design",
    tall: true,
  },
  {
    src: "https://images.unsplash.com/photo-1629079447792-066af3327de5?auto=format&fit=crop&w=1200&q=80",
    label: "Dining & Kitchens",
  },
  {
    src: "https://images.unsplash.com/photo-1787422660647-3be04b53f8d2?auto=format&fit=crop&w=1200&q=80",
    label: "Construction",
  },
  {
    src: "https://images.pexels.com/photos/280239/pexels-photo-280239.jpeg?auto=compress&cs=tinysrgb&w=1200",
    label: "Living Areas",
    tall: true,
  },
  {
    src: "https://images.pexels.com/photos/5866151/pexels-photo-5866151.jpeg?auto=compress&cs=tinysrgb&w=1200",
    label: "Suburban Classics",
  },
  {
    src: "https://images.pexels.com/photos/7031604/pexels-photo-7031604.jpeg?auto=compress&cs=tinysrgb&w=1200",
    label: "Landscaping",
    tall: true,
  },
];
